'use client';

import { useState, useEffect, useCallback } from 'react';

function useAudio(url?: string) {
  enum PlayStatus  {
    PLAY = 'play',
    PAUSE = 'pause',
  }

  const [ audio, setAudio ] = useState<HTMLAudioElement>();
  // const [canPlay, setCanplay] = useState(false);
  const [ audioStatus, setAudioStatus ] = useState(PlayStatus.PAUSE);
  const [currentTime, setCurrentTime] = useState<number>(0);

  const handleDurationChange: (e?: Event) => void = () => {
    setCurrentTime(Math.round(audio?.currentTime || 0));
  };

  useEffect(() => {
    setAudio(new Audio(url));
  }, [url]);

  const play = useCallback(() => {
    audio?.play();
  }, [audio]);

  const pause = useCallback(() => {
    if (audio) {
      audio.pause();
    } else {
      console.log('not pause', audio);
    }
  }, [audio]);


  useEffect(() => {
    return () => {
      pause();
    }
  }, [audio]);


  const changeAudio: (url: string) => void = (changeUrl: string): void => {
    if (audio) {
      audio.pause();
    }
    setAudio(new Audio(changeUrl));
  };

  const changeCurrentTime = (cur: number | number[]) => {
    if (typeof cur === 'number') {
      if (cur < 0 || Object.is(cur, NaN)) {
        cur = 0;
      }
      setCurrentTime(cur);
      audio!.currentTime = cur;
    }
  };

  audio?.addEventListener('timeupdate', handleDurationChange, false );
  audio?.addEventListener('play', () => {
    if (PlayStatus.PLAY !== audioStatus) {
      setAudioStatus(PlayStatus.PLAY);
    }
    console.log('play listener play');
  }, false);

  audio?.addEventListener('pause', () => {
    if (PlayStatus.PAUSE !== audioStatus) {
      setAudioStatus(PlayStatus.PAUSE);
    }
    // setAudioStatus(PlayStatus.PAUSE);
    console.log('pause listener pause');
  }, false);

  return {
    audio: audio,
    audioStatus: audioStatus,
    currentTime: currentTime,
    duration: Math.round(audio?.duration || 0),
    setAudio: changeAudio,
    play: play,
    pause: pause,
    changeCurrentTime,
  };
}

export default useAudio;
